import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "multivendor"
    }}>{`MultiVendor`}</h1>
    <h2 {...{
      "id": "create-new-shop"
    }}>{`Create New Shop`}</h2>
    <p>{`To create new shop login as an `}<inlineCode parentName="p">{`administrator`}</inlineCode>{` or create a new account for creating `}<inlineCode parentName="p">{`shop`}</inlineCode></p>
    <p><img alt="RegisterNewAccount.png" src={require("../images/RegisterNewAccount.png")} /></p>
    <p><img alt="AccountInfo.png" src={require("../images/AccountInfo.png")} /></p>
    <p>{`After creating the account you'll be redirected to this page,`}</p>
    <p><img alt="Vendor.png" src={require("../images/Vendor.png")} /></p>
    <p>{`After that, click `}<inlineCode parentName="p">{`Create Shop`}</inlineCode></p>
    <p><img alt="CreateShop.png" src={require("../images/CreateShop.png")} /></p>
    <p>{`And provide all the information for the `}<inlineCode parentName="p">{`store`}</inlineCode>{`.`}</p>
    <p>{`After creating the shop you'll redirect to this page,`}</p>
    <p><img alt="CreatedShop.png" src={require("../images/CreatedShop.png")} /></p>
    <p>{`By default, the shop will be inactive. Only `}<inlineCode parentName="p">{`administrator`}</inlineCode>{` can active a shop.`}</p>
    <p>{`From `}<inlineCode parentName="p">{`administrator account go to `}</inlineCode>{`shop`}<inlineCode parentName="p">{`and click`}</inlineCode>{`tick`}<inlineCode parentName="p">{`mark to`}</inlineCode>{`activate`}<inlineCode parentName="p">{`or`}</inlineCode>{`deactivate\` a shop.`}</p>
    <p><img alt="ActivateShop.png" src={require("../images/ActivateShop.png")} /></p>
    <p>{`After `}<inlineCode parentName="p">{`activate`}</inlineCode>{` the shop by `}<inlineCode parentName="p">{`administrator`}</inlineCode>{` the `}<inlineCode parentName="p">{`vendor`}</inlineCode>{` dashboard will be like this,`}</p>
    <p><img alt="ActivatedShop.png" src={require("../images/ActivatedShop.png")} /></p>
    <p>{`After click on `}<inlineCode parentName="p">{`shop`}</inlineCode>{`, you'll be redirected to dashboard page,`}</p>
    <p><img alt="ShopDashboard.png" src={require("../images/ShopDashboard.png")} /></p>
    <p>{`From this dashboard, you can maintain the shop,`}</p>
    <h4 {...{
      "id": "dashboard"
    }}>{`Dashboard:`}</h4>
    <p><img alt="Dashboard.png" src={require("../images/Dashboard.png")} /></p>
    <h4 {...{
      "id": "attributes"
    }}>{`Attributes:`}</h4>
    <p><img alt="Attributes.png" src={require("../images/Attributes.png")} /></p>
    <h4 {...{
      "id": "products"
    }}>{`Products:`}</h4>
    <p><img alt="Products.png" src={require("../images/Products.png")} /></p>
    <h4 {...{
      "id": "order"
    }}>{`Order:`}</h4>
    <p><img alt="Order.png" src={require("../images/Order.png")} /></p>
    <h4 {...{
      "id": "staff"
    }}>{`Staff:`}</h4>
    <p><img alt="Staff.png" src={require("../images/Staff.png")} /></p>
    <h4 {...{
      "id": "withdraw"
    }}>{`WithDraw:`}</h4>
    <p><img alt="WithDraw.png" src={require("../images/WithDraw.png")} /></p>
    <h2 {...{
      "id": "user-roles"
    }}>{`User Roles:`}</h2>
    <h4 {...{
      "id": "super-admin"
    }}>{`Super Admin:`}</h4>
    <p>{`Super admin can do everything. the admin can maintain and edit every store on the site.`}</p>
    <h4 {...{
      "id": "store-owner"
    }}>{`Store Owner:`}</h4>
    <p>{`Store owner can edit or main it's store, staff or payment.`}</p>
    <h4 {...{
      "id": "staff-1"
    }}>{`Staff:`}</h4>
    <p>{`The staff of a store has similar permission as store owner, but the staff can't update the store or withdraw payment.`}</p>
    <h2 {...{
      "id": "withdraw-payment"
    }}>{`Withdraw Payment:`}</h2>
    <p>{`Only the store owner can withdraw its payment. To do that go to your shop dashboard -> withdraws -> Request a withdraw,`}</p>
    <p><img alt="AskWithdraw.png" src={require("../images/AskWithdraw.png")} /></p>
    <p><img alt="SubmitWithdraw.png" src={require("../images/SubmitWithdraw.png")} /></p>
    <p>{`After request payment, the dashboard will be like this,`}</p>
    <p><img alt="AfterRequest.png" src={require("../images/AfterRequest.png")} /></p>
    <p>{`After request, the admin has to be approved the admin.`}</p>
    <p><img alt="AdminRequest.png" src={require("../images/AdminRequest.png")} />{`
`}<img alt="Aproved.png" src={require("../images/Aproved.png")} /></p>
    <p>{`After approved,
`}<img alt="AfterAproved.png" src={require("../images/AfterAproved.png")} /></p>
    <h2 {...{
      "id": "frontend-shop"
    }}>{`FrontEnd Shop`}</h2>
    <p>{`From frontend when customers click on the `}<inlineCode parentName="p">{`shop`}</inlineCode>{` page they'll get all the shops as a card list,`}</p>
    <p><img alt="ShopList.png" src={require("../images/ShopList.png")} /></p>
    <p>{`Also when customers click on a product they will get the seller link,`}</p>
    <p><img alt="Seller.png" src={require("../images/Seller.png")} /></p>
    <p>{`After clicking the `}<inlineCode parentName="p">{`seller link`}</inlineCode>{` they will redirect to the seller shop page,`}</p>
    <p><img alt="SellerDashboard.png" src={require("../images/SellerDashboard.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      